import { ko, enUS } from 'date-fns/locale';
import { useTranslation } from 'react-i18next';

import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider as MuiLocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode;
};

export default function LocalizationProvider({ children }: Readonly<Props>) {
  const { i18n } = useTranslation();
  const adapterLocale = i18n.language.startsWith('ko') ? ko : enUS;

  return (
    <MuiLocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={adapterLocale}>
      {children}
    </MuiLocalizationProvider>
  );
}
